// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-carousel__swiper-wrapper{-webkit-transition-timing-function:linear!important;transition-timing-function:linear!important}.h-carousel__swiper-slide{width:auto}", ""]);
// Exports
module.exports = exports;
